import type { CityConfig } from "../city-template/types";

export const wentzvilleMOConfig: CityConfig = {
  city: "Wentzville",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "wentzville-mo",
  route: "/cities/wentzville-mo",
  title: "Emergency Passport Wentzville, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Wentzville, MO — as fast as 24 hours. Serving St. Charles County and the I-70 corridor. A+ BBB rated registered State Dept. courier serving western St. Charles County. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Wentzville, MO",
  heroSubtitle: "Western St. Charles County business trip to Germany with a week's notice? Family vacation to Ireland and the kids' passports expired? GM plant business travel needs fast documents? We help Wentzville residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Wentzville%20Missouri%20western%20St%20Charles%20County%20suburban%20landscape%20crossroads%20of%20Interstate%2070%20and%20Interstate%2064%20modern%20suburban%20development%20historic%20downtown%20district%20GM%20assembly%20plant%20area%20golden%20hour%20warm%20light%20professional%20photography&width=1800&height=700&seq=wentzville-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Wentzville Missouri western St. Charles County suburban crossroads at golden hour",
  geoPosition: "38.8114;-90.8535",
  geoPlacename: "Wentzville, Missouri",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 315 miles northeast of Wentzville via I-55",
  },
  nearbyCitiesZips: [
    { name: "Wentzville", zips: "63385" },
    { name: "Lake Saint Louis", zips: "63367" },
    { name: "O'Fallon", zips: "63366, 63368" },
    { name: "Troy", zips: "63379" },
    { name: "Warrenton", zips: "63383" },
    { name: "Wright City", zips: "63390" },
    { name: "Foristell", zips: "63348" },
    { name: "Moscow Mills", zips: "63362" },
    { name: "Winfield", zips: "63389" },
    { name: "St. Charles", zips: "63301, 63303" },
    { name: "St. Peters", zips: "63376" },
    { name: "Dardenne Prairie", zips: "63368" },
    { name: "Cottleville", zips: "63304" },
    { name: "Weldon Spring", zips: "63304" },
    { name: "Bowling Green", zips: "63334" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent St. Charles County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "I-70 Corridor Hub", desc: "Serving Wentzville, Lake Saint Louis, Troy, and western St. Charles County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in St. Charles, MO", route: "/cities/st-charles" },
    { name: "Fast passport renewal in O'Fallon, MO", route: "/cities/ofallon-mo" },
    { name: "Emergency passport help in Chesterfield, MO", route: "/cities/chesterfield-mo" },
    { name: "Urgent passport services in St. Louis, MO", route: "/cities/st-louis" },
    { name: "Same-day passport help in Chicago, IL", route: "/cities/chicago" },
    { name: "Passport courier services in Springfield, MO", route: "/cities/springfield-mo" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Wentzville remotely via secure courier. We do not have a walk-in office in Wentzville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for St. Charles County and the I-70 corridor.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of St. Charles County and western I-70 communities including Lincoln County and Warren County",
  serviceAreaIntro: "From the suburban communities of Wentzville and the lakeside neighborhoods of Lake Saint Louis to the historic charm of downtown St. Charles and the retail district of St. Peters, from the growing subdivisions of O'Fallon and Dardenne Prairie to the small towns of Troy and Warrenton — Fast Passport Center serves all of western St. Charles County and the I-70 corridor. We regularly help travelers from Wentzville, Lake Saint Louis, and the surrounding communities get their passports fast without the 5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Wentzville neighborhoods and the surrounding western St. Charles County area including Lake Saint Louis, O'Fallon, Troy, Warrenton, Wright City, Foristell, Moscow Mills, and Winfield. If you are anywhere in St. Charles County, Lincoln County, or along the I-70 corridor, we have you covered.",
  howItWorksIntro: "Most Wentzville travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Wentzville travelers often face a 5-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Wentzville and St. Charles County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Wentzville? Here are the most common ones we hear from St. Charles County travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Wentzville travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Jennifer T.",
      location: "Wentzville, MO",
      rating: 5,
      text: "Our London trip was in 4 days and my husband's passport was expired. Fast Passport Center got his renewal in 30 hours. I never left Wentzville. From the I-70 corridor to Heathrow in under a week — incredible service!",
      service: "Passport Renewal",
    },
    {
      name: "Mike R.",
      location: "Lake Saint Louis, MO",
      rating: 5,
      text: "Business trip to Japan with 6 days notice. Fast Passport Center handled everything. The dedicated agent was amazing — daily updates, zero stress. Best service I've ever used for travel documents.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah K.",
      location: "Wentzville, MO",
      rating: 5,
      text: "All three kids needed first passports for our Mediterranean cruise. Fast Passport Center walked us through the child process step by step. Got all three in 4 days. Lifesaver for St. Charles County families!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "wentzville-1",
      name: "Wentzville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 E Allen St",
      city: "Wentzville",
      state: "MO",
      zip: "63385",
      phone: "(636) 327-6111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Wentzville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Wentzville facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "wentzville-2",
      name: "St. Charles County — Administration Building",
      type: "County Government Passport Acceptance",
      address: "201 N 2nd St",
      city: "St. Charles",
      state: "MO",
      zip: "63301",
      phone: "(636) 949-7505",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "15 miles east of Wentzville",
      website: "https://www.sccmo.org",
      websiteLabel: "St. Charles County Recorder",
      notes: "Accepts passport applications at the county seat. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "wentzville-3",
      name: "O'Fallon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 Tierra Dr",
      city: "O'Fallon",
      state: "MO",
      zip: "63366",
      phone: "(636) 240-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles east of Wentzville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves O'Fallon and eastern Wentzville area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "wentzville-4",
      name: "Troy Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "507 E Cherry St",
      city: "Troy",
      state: "MO",
      zip: "63379",
      phone: "(636) 528-6111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles northwest of Wentzville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Troy and Lincoln County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "wentzville-5",
      name: "Warrenton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "501 E Booneslick Rd",
      city: "Warrenton",
      state: "MO",
      zip: "63383",
      phone: "(636) 456-6111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles west of Wentzville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Warren County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Wentzville photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at St. Charles County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Wentzville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many St. Charles County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Wentzville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Wentzville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Wentzville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Wentzville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Wentzville for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Wentzville?", a: "Fast Passport Center offers fast passport renewal in Wentzville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Wentzville?", a: "The nearest regional passport agency to Wentzville is the Chicago Passport Agency, approximately 315 miles northeast via I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Wentzville without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Wentzville?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5 hours from Wentzville — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for St. Charles County residents." },
    { q: "Do you serve the entire western St. Charles County area?", a: "Absolutely. Fast Passport Center serves all of western St. Charles County including Wentzville, Lake Saint Louis, O'Fallon, Troy, Warrenton, and surrounding areas. Our courier service works seamlessly from any address in St. Charles County, Lincoln County, or Warren County." },
    { q: "Can I expedite a child passport in Wentzville?", a: "Yes. Fast Passport Center expedites child passports in Wentzville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk St. Charles County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Wentzville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Wentzville", address: "1971 Wentzville Pkwy, Wentzville, MO 63385", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Wentzville", address: "1201 Wentzville Pkwy, Wentzville, MO 63385", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Lake Saint Louis", address: "6302 Ronald Reagan Dr, Lake Saint Louis, MO 63367", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — O'Fallon", address: "1307 State Hwy K, O'Fallon, MO 63366", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Wentzville License Office",
      address: "7 W Pearce Blvd, Wentzville, MO 63385",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Missouri DOR — O'Fallon License Office",
      address: "2490 Hwy K, O'Fallon, MO 63368",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves O'Fallon and Dardenne Prairie. REAL ID available.",
      featured: false,
    },
    {
      name: "Missouri DOR — Troy License Office",
      address: "105 N Lincoln Dr, Troy, MO 63379",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Lincoln County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "45 miles southeast of Wentzville",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international airport with direct flights worldwide. About 50 minutes from Wentzville via I-70/I-270.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: true,
    },
    {
      code: "COU",
      name: "Columbia Regional Airport",
      distance: "95 miles west of Wentzville",
      address: "11300 S Airport Dr, Columbia, MO 65201",
      note: "Regional airport with direct flights to major hubs. About 1 hour 40 minutes from Wentzville via I-70.",
      flightUrl: "https://www.flycou.com/",
      flightLabel: "COU Airport",
      featured: false,
    },
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "225 miles west of Wentzville",
      address: "1 Kansas City Blvd, Kansas City, MO 64153",
      note: "Major airport serving western Missouri. About 3 hours 30 minutes from Wentzville via I-70.",
      flightUrl: "https://www.flykc.com/",
      flightLabel: "MCI Airport",
      featured: false,
    },
  ],
};